export default {
  setGroupList(state, { groups }) {
    state.groupList = groups
  },
  setGroupInfo(state, info) {
    state.groupInfo = info
  },
  setOtherGroupsList(state, groups) {
    state.otherGroupsList = groups
  }
}
